import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_3 = { class: "md:col-span-12" }
const _hoisted_4 = { class: "md:col-span-12" }
const _hoisted_5 = { class: "rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 lg:grid-cols-[minmax(0,1fr)_auto]" }
const _hoisted_7 = { class: "flex min-w-0 items-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5" }
const _hoisted_8 = { class: "min-w-0" }
const _hoisted_9 = { class: "truncate text-[15px] font-semibold text-slate-900" }
const _hoisted_10 = { class: "flex shrink-0 flex-wrap gap-2 lg:justify-end" }
const _hoisted_11 = { enctype: "multipart/form-data" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "md:col-span-12" }
const _hoisted_14 = { class: "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_15 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_16 = { class: "min-w-full divide-y divide-slate-200 text-[15px]" }
const _hoisted_17 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_18 = { class: "px-4 py-3" }
const _hoisted_19 = { class: "flex min-w-0 items-center gap-3" }
const _hoisted_20 = { class: "min-w-0 truncate text-slate-900" }
const _hoisted_21 = { class: "px-4 py-3 text-slate-600" }
const _hoisted_22 = { class: "px-4 py-3 text-right" }
const _hoisted_23 = {
  key: 1,
  class: "px-4 py-8 text-center"
}
const _hoisted_24 = {
  key: 0,
  class: "w-full"
}
const _hoisted_25 = { class: "w-full" }
const _hoisted_26 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_27 = { class: "flex items-center gap-3" }
const _hoisted_28 = { class: "relative inline-flex w-full max-w-[18em]" }
const _hoisted_29 = {
  key: 1,
  class: "md:col-span-12"
}
const _hoisted_30 = { class: "rounded-lg border border-red-200 bg-red-50 p-4" }
const _hoisted_31 = { class: "whitespace-pre-wrap text-[15px] font-semibold text-red-700" }
const _hoisted_32 = {
  key: 2,
  class: "md:col-span-12"
}
const _hoisted_33 = { class: "w-full" }
const _hoisted_34 = { id: "loading" }
const _hoisted_35 = { class: "w-full" }
const _hoisted_36 = { id: "loadingProcess" }
const _hoisted_37 = { class: "w-full" }
const _hoisted_38 = { id: "loadingExport" }
const _hoisted_39 = { id: "sendMessage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Panel, { header: "Thêm dân cư vào tổ" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("section", _hoisted_3, [
              _createVNode(_component_Button, {
                label: "Tải danh sách mẫu",
                severity: "secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.downLoadFile())),
                icon: "pi pi-cloud-download"
              })
            ]),
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-3" }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", { class: "m-0 text-[15px] font-bold text-slate-900" }, "Tập tin danh sách dân cư"),
                    _createElementVNode("div", { class: "mt-1 text-[13px] font-medium text-slate-500" }, " XLSX, XLS (hỗ trợ chọn nhiều tập tin) ")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700" }, [
                      _createElementVNode("i", { class: "pi pi-file-excel" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString($setup.listFileName.length > 0
                        ? `Đã chọn ${$setup.listFileName.length} tập tin`
                        : "Chưa chọn tập tin"), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-sm text-slate-500" }, " Có thể chọn nhiều tập tin cùng lúc ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Button, {
                      outlined: "",
                      label: "Đính kèm tập tin",
                      icon: "pi pi-paperclip",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectFile())),
                      disabled: $setup.loadingBar
                    }, null, 8, ["disabled"]),
                    _createVNode(_component_Button, {
                      label: "Đăng danh sách",
                      icon: "pi pi-cloud-upload",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.upload())),
                      loading: $setup.loadingBar,
                      disabled: $setup.loadingBar || $setup.listFileName.length < 1
                    }, null, 8, ["loading", "disabled"])
                  ])
                ])
              ]),
              _createElementVNode("form", _hoisted_11, [
                _createElementVNode("input", {
                  id: "myFile",
                  type: "file",
                  class: "hidden",
                  accept: ".xlsx,.xls",
                  name: "files",
                  multiple: "multiple",
                  onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.fileChange($event.target.files))),
                  disabled: $setup.loadingBar
                }, null, 40, _hoisted_12)
              ])
            ]),
            _createElementVNode("section", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-3" }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "text-[15px] font-bold text-slate-900" }, " Tập tin đã chọn "),
                    _createElementVNode("div", { class: "text-[13px] font-medium text-slate-500" }, " Kiểm tra danh sách trước khi đăng danh sách. ")
                  ])
                ], -1)),
                ($setup.listFileName.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("table", _hoisted_16, [
                        _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "bg-slate-100 text-left text-xs font-bold uppercase text-slate-600" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "px-4 py-3" }, "Tập tin"),
                            _createElementVNode("th", { class: "w-36 px-4 py-3" }, "Dung lượng"),
                            _createElementVNode("th", { class: "w-28 px-4 py-3 text-right" }, "Thao tác")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listFileName, (file) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: file.nameFile,
                              class: "transition hover:bg-teal-50/40"
                            }, [
                              _createElementVNode("td", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700" }, [
                                    _createElementVNode("i", { class: "pi pi-file-excel" })
                                  ], -1)),
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(file.nameFile), 1)
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_21, _toDisplayString($setup.formatFileSize(file.value?.size)), 1),
                              _createElementVNode("td", _hoisted_22, [
                                _createVNode(_component_Button, {
                                  severity: "danger",
                                  label: "Xóa",
                                  icon: "pi pi-trash",
                                  onClick: ($event: any) => ($setup.deleteFile(file.nameFile)),
                                  class: "!min-h-[36px] px-3 py-1.5"
                                }, null, 8, ["onClick"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("span", { class: "inline-flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100 text-slate-400" }, [
                        _createElementVNode("i", { class: "pi pi-folder-open" })
                      ], -1),
                      _createElementVNode("p", { class: "mt-3 text-sm font-semibold text-slate-600" }, " Chưa có tập tin nào được chọn. ", -1)
                    ]))]))
              ])
            ]),
            ($setup.resDetail.failNumber > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_Panel, { header: "Danh sách hồ sơ lỗi" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_DataTable, {
                          value: $setup.resDetail.listError,
                          paginator: true,
                          stripedRows: "",
                          rows: 10,
                          rowsPerPageOptions: [10, 25, 50],
                          rowHover: true,
                          filters: $setup.filters,
                          "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => (($setup.filters) = $event)),
                          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                          globalFilterFields: ['fullName', 'phoneNumber'],
                          currentPageReportTemplate: "Có tổng số {totalRecords} dân cư lỗi",
                          columnResizeMode: "fit | expand"
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_Button, {
                                  type: "button",
                                  icon: "pi pi-filter-slash",
                                  label: "Xoá lọc",
                                  outlined: "",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.clearFilter()))
                                }),
                                _createElementVNode("span", _hoisted_28, [
                                  _cache[19] || (_cache[19] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                                  _createVNode(_component_InputText, {
                                    class: "pl-9",
                                    modelValue: $setup.filters['global'].value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters['global'].value) = $event)),
                                    placeholder: "Tìm theo tên hoặc số điện thoại"
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_Column, {
                              field: "fullName",
                              header: "Họ và tên",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "phoneNumber",
                              header: "Số điện thoại",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "message",
                              header: "Thông báo",
                              sortable: ""
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "filters"])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            ($setup.res)
              ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", _hoisted_31, _toDisplayString($setup.res), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.show)
              ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                  _createVNode(_component_Button, {
                    label: "Thêm danh sách dân cư",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.createList())),
                    icon: "pi pi-plus-circle",
                    loading: $setup.loadingBarProcess,
                    class: "w-full"
                  }, null, 8, ["loading"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_Dialog, {
        header: "Đăng danh sách",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (($setup.loadingBar) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_34, [
            _cache[20] || (_cache[20] = _createElementVNode("label", null, "Đang đăng danh sách...", -1)),
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              class: "h-[0.3em]"
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createVNode(_component_Dialog, {
        header: "Đang xử lý",
        visible: $setup.loadingBarProcess,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (($setup.loadingBarProcess) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_36, [
            _cache[21] || (_cache[21] = _createElementVNode("label", null, "Đang thêm danh sách, vui lòng chờ...", -1)),
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              class: "h-[0.3em]"
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_Dialog, {
        header: "Đang xử lý",
        visible: $setup.loadingExport,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (($setup.loadingExport) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_38, [
            _cache[22] || (_cache[22] = _createElementVNode("label", null, "Đang xuất dữ liệu, vui lòng chờ...", -1)),
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              class: "h-[0.3em]"
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        header: "Đang xử lý",
        visible: $setup.sendMessage,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (($setup.sendMessage) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_39, [
            _cache[23] || (_cache[23] = _createElementVNode("label", null, "Đang gửi thông báo thuế, vui lòng chờ ....", -1)),
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              class: "h-[0.3em]"
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ])
  ], 64))
}